<template>
  <vue-slider
    :min="min"
    :max="max"
    :data="data"
    v-model="_value"
    :marks="marks"
    :disabled="disabled"
    :tooltip="tooltip"
    :dotSize="dotSize"
    :interval="interval"
    :minRange="minRange"
    :enableCross="enableCross"
    :lazy="lazy"
    :process="process"
    :direction="direction"
  >
    <template v-slot:label="{ active, value }">
      <div :class="['vue-slider-mark-label', css, { active }]">{{ formatter(value) }}</div>
    </template>
  </vue-slider>
</template>

<script>
export default {
  props: {
    min: Number,
    max: Number,
    data: [Array, Object],
    value: [Number, Array],
    marks: Array,
    css: Array,
    formatter: Function,
    interval: Number,
    disabled: Boolean,
    tooltip: String,
    dotSize: [Number, Array],
    minRange: Number,
    enableCross: Boolean,
    lazy: Boolean,
    process: {
      type: Boolean,
      default: true,
    },
    direction: String,
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('update:value', newVal)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.vue-slider-disabled {
  opacity: 0.7;
}
.vue-slider-disabled,
/deep/.vue-slider-dot-disabled,
/deep/.vue-slider-dot-handle-disabled {
  cursor: default;
}
</style>
